function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { tempo } from "../../system";
import { getProgressProps, spin } from "./utils";
import { Shape } from "./shape";
import { Circle } from "./circle";
/**
 * CircularProgress is used to indicate the progress of an activity.
 * It is built using `svg` and `circle` components with support for
 * theming, gradient and `indeterminate` state
 * @see Docs https://chakra-ui.com/circularprogress
 * @todo add theming support for circular progress
 */ export const CircularProgress = (props)=>{
    const { capIsRound, children, color = 'background.accent.primary.default', gradient, getValueText, isIndeterminate, max = 100, min = 0, size = '48px', thickness = '10px', trackColor, value, valueText } = props, rest = _object_without_properties(props, [
        "capIsRound",
        "children",
        "color",
        "gradient",
        "getValueText",
        "isIndeterminate",
        "max",
        "min",
        "size",
        "thickness",
        "trackColor",
        "value",
        "valueText"
    ]);
    const progress = getProgressProps({
        min,
        max,
        value,
        valueText,
        getValueText,
        isIndeterminate
    });
    var _progress_percent;
    const determinant = isIndeterminate ? undefined : ((_progress_percent = progress.percent) !== null && _progress_percent !== void 0 ? _progress_percent : 0) * 2.64;
    const strokeDasharray = determinant == null ? undefined : `${determinant} ${264 - determinant}`;
    const indicatorProps = isIndeterminate ? {
        css: {
            animation: `${spin} 1.5s linear infinite`
        }
    } : {
        strokeDashoffset: 66,
        strokeDasharray,
        transitionProperty: 'stroke-dasharray, stroke',
        transitionDuration: '0.6s',
        transitionTimingFunction: 'ease'
    };
    const rootStyles = {
        display: 'inline-block',
        position: 'relative',
        verticalAlign: 'middle',
        fontSize: size
    };
    const unique = Math.random().toString();
    return /*#__PURE__*/ _jsxs(tempo.div, _object_spread_props(_object_spread({
        className: "chakra-progress"
    }, progress.bind, rest), {
        __css: rootStyles,
        children: [
            /*#__PURE__*/ _jsxs(Shape, {
                size: size,
                isIndeterminate: isIndeterminate,
                children: [
                    (gradient === null || gradient === void 0 ? void 0 : gradient.length) ? /*#__PURE__*/ _jsx("defs", {
                        children: /*#__PURE__*/ _jsx("linearGradient", {
                            id: 'gradient' + unique,
                            x1: "0%",
                            y1: "0%",
                            x2: "0%",
                            y2: "100%",
                            children: gradient.map(({ stop, color })=>/*#__PURE__*/ _jsx("stop", {
                                    offset: `${stop * 100}%`,
                                    stopColor: color
                                }, stop))
                        })
                    }) : null,
                    /*#__PURE__*/ _jsx(Circle, {
                        stroke: trackColor !== null && trackColor !== void 0 ? trackColor : 'gray.100',
                        _dark: {
                            stroke: trackColor !== null && trackColor !== void 0 ? trackColor : 'gray.500'
                        },
                        strokeWidth: thickness,
                        className: "chakra-progress__track"
                    }),
                    /*#__PURE__*/ _jsx(Circle, _object_spread({
                        stroke: (gradient === null || gradient === void 0 ? void 0 : gradient.length) ? `url(#gradient${unique})` : color,
                        strokeWidth: thickness,
                        className: "chakra-progress__indicator",
                        strokeLinecap: capIsRound ? 'round' : undefined,
                        /**
					 * fix issue in Safari where indicator still shows when value is 0
					 * @see Issue https://github.com/chakra-ui/chakra-ui/issues/3754
					 */ opacity: progress.value === 0 && !isIndeterminate ? 0 : undefined
                    }, indicatorProps))
                ]
            }),
            children
        ]
    }));
};
CircularProgress.displayName = 'CircularProgress';
export { CircularProgressLabel } from "@chakra-ui/react";

//# sourceMappingURL=index.js.map